import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface ThemeButtonProps {
    theme: string;
    icon: IconDefinition;
    isSelected: boolean;
    onClick: () => void;
}

const ThemeButton: React.FC<ThemeButtonProps> = ({ theme, icon, isSelected, onClick }) => (
    <button
        onClick={onClick}
        className={`flex items-center justify-center p-2 rounded-lg transition-all duration-200 flex-1 ${
            isSelected
                ? 'bg-blue-400 dark:bg-blue-500 text-black dark:text-white'
                : 'bg-neutral-200 text-neutral-800 hover:bg-neutral-100 dark:bg-neutral-600 dark:text-neutral-300 dark:hover:bg-neutral-500'
        }`}
    >
        <FontAwesomeIcon icon={icon} className="mr-1" />
        <span className="capitalize text-xs">{theme}</span>
    </button>
);

export default ThemeButton;
